<div *ngIf="!this.plt.tabMenu"
     class="header">
    <h2>{{ 'CHAT_GROUPS_CHANNELS' | translate }}</h2>
</div>
<div class="content">

    <ng-container *ngIf="event?.can(user.selected_participant.group_id, 'allow_chat_group_creation') || event?.can(user.selected_participant.group_id, 'allow_private_chat_group_creation') || event?.can(user.selected_participant.group_id, 'allow_secured_chat_group_creation')">
        <ion-button (click)="addChatGroup()"
                    class="add-chat-group">
            <span>+ </span>{{ 'CHAT_GROUP_NEW' | translate }}
        </ion-button>
    </ng-container>

    <ng-container *ngFor="let chatGroup of assignedChatGroups">
        <!-- broadcast messages -->
        <div *ngIf="!chatGroup.joined"
             class="chat-group-item">
            <div class="details">
                <h3>
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-hashtag.svg"
                              class="icon fill-dark"></svg-icon>{{ chatGroup.name }}
                </h3>
                <div class="chat-group-item-detail">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-attendee.svg"
                              class="icon fill-medium"></svg-icon> {{ chatGroup.number_attendees }}
                    <ng-container *ngIf="chatGroup.description">
                        - <span [innerHTML]="chatGroup.description | striphtml"></span>
                    </ng-container>
                </div>
            </div>
            <ion-button *ngIf="(chatGroup.joined || chatGroup.invited || chatGroup.status != 2) && !user.selected_participant.not_contactable"
                        (click)="joinChatGroup(chatGroup)">
                {{ 'CHAT_GROUPS_JOIN' | translate }}
            </ion-button>

            <ion-button *ngIf="!chatGroup.joined && !chatGroup.invited && chatGroup.status == 2 && !user.selected_participant.not_contactable"
                        (click)="openPasswordModal($event, chatGroup)"
                        class="password-lock">
                <svg-icon [applyClass]="true"
                          slot="start"
                          src="/assets/icons/lock.svg"
                          class=""></svg-icon>
                {{ 'CHAT_GROUPS_JOIN' | translate }}
            </ion-button>
        </div>
    </ng-container>
</div>
